<template>
  <div class="background">
    <div class="container" v-if="!showSpinner">
      <head-title class="head-title">
        Subscription Plan Change
      </head-title>
      <div class="subscription-plan__starting" v-if="tariffWillBeChangedAt">
        The new plan will become active on {{tariffWillBeChangedAt | format(dateFormat)}} once you pick it
      </div>

      <div class="table-wrap">
        <table class="table">
          <thead>
            <tr class="table__tr">
              <th class="table__th table__th_space"></th>
              <th class="table__th">
                <div class="subscription-plan__name">{{freeTariff.name}}</div>
                <div class="subscription-plan__cost">Free, forever!</div>
              </th>
              <th class="table__th">
                <div class="subscription-plan__name">{{silverTariff.name}}</div>
                <div class="subscription-plan__cost">{{silverTariff.cost | formatMoney}} / Month</div>
              </th>
              <th class="table__th">
                <div class="subscription-plan__name">{{goldTariff.name}}</div>
                <div class="subscription-plan__cost">{{goldTariff.cost | formatMoney}} / Month</div>
              </th>
              <th class="table__th table__th_offset"/>
            </tr>
          </thead>

          <tbody class="tbody">
            <!-- <tr class="table__tr">
              <td class="table__td table__td_item">Platform</td>
              <td class="table__td">{{freeTariff.alertsCount}}</td>
              <td class="table__td">{{silverTariff.alertsCount}}</td>
              <td class="table__td">
                {{goldTariff.alertsCount}}
                <icon-base class="icon-base" red>
                  <icon-infinity />
                </icon-base>
              </td>
            </tr> -->
            <tr class="table__tr">
              <td class="table__td table__td_item">Push</td>
              <td class="table__td">{{freeTariff.limitPush}}</td>
              <td class="table__td">{{silverTariff.limitPush}}</td>
              <td class="table__td">
                {{goldTariff.limitPush}}
                <!-- <icon-base class="icon-base" red>
                  <icon-infinity />
                </icon-base> -->
              </td>
              <td class="table__td table__td_offset"></td>
            </tr>
            <tr class="table__tr">
              <td class="table__td table__td_item">Email</td>
              <td class="table__td">{{freeTariff.limitEmail}}</td>
              <td class="table__td">{{silverTariff.limitEmail}}</td>
              <td class="table__td">
                {{goldTariff.limitEmail}}
                <!-- <icon-base class="icon-base" red>
                  <icon-infinity />
                </icon-base> -->
              </td>
              <td class="table__td table__td_offset"/>
            </tr>
            <tr class="table__tr">
              <td class="table__td table__td_item">SMS</td>
              <td class="table__td">{{freeTariff.limitSMS}}</td>
              <td class="table__td">{{silverTariff.limitSMS}}</td>
              <td class="table__td">
                {{goldTariff.limitSMS}}
                <!-- <icon-base class="icon-base" red>
                  <icon-infinity />
                </icon-base> -->
              </td>
              <td class="table__td table__td_offset"/>
            </tr>
            <tr class="table__tr">
              <td class="table__td table__td_item">Webhook</td>
              <td class="table__td">{{freeTariff.limitWebhook}}</td>
              <td class="table__td">{{silverTariff.limitWebhook}}</td>
              <td class="table__td">
                {{goldTariff.limitWebhook}}
                <!-- <icon-base class="icon-base" red>
                  <icon-infinity />
                </icon-base> -->
              </td>
              <td class="table__td table__td_offset"/>
            </tr>
            <!-- <tr class="table__tr">
              <td class="table__td table__td_item">Feature one</td>
              <td class="table__td">
                <icon-base class="icon-base" red>
                  <icon-check/>
                </icon-base>
              </td>
              <td class="table__td">
                <icon-base class="icon-base" red>
                  <icon-check/>
                </icon-base>
              </td>
              <td class="table__td">
                <icon-base class="icon-base" red>
                  <icon-check/>
                </icon-base>
              </td>
            </tr>
            <tr class="table__tr">
              <td class="table__td table__td_item">Feature two</td>
              <td class="table__td">
                <div class="ellipse"></div>
              </td>
              <td class="table__td">
                <icon-base class="icon-base" red>
                  <icon-check/>
                </icon-base>
              </td>
              <td class="table__td">
                <icon-base class="icon-base" red>
                  <icon-check/>
                </icon-base>
              </td>
            </tr>
            <tr class="table__tr">
              <td class="table__td table__td_item">Feature three</td>
              <td class="table__td">
                <div class="ellipse"></div>
              </td>
              <td class="table__td">
                <div class="ellipse"></div>
              </td>
              <td class="table__td">
                <icon-base class="icon-base" red>
                  <icon-check/>
                </icon-base>
              </td>
            </tr>
            <tr class="table__tr">
              <td class="table__td table__td_item">Feature four</td>
              <td class="table__td">
                <div class="ellipse"></div>
              </td>
              <td class="table__td">
                <div class="ellipse"></div>
              </td>
              <td class="table__td">
                <icon-base class="icon-base" red>
                  <icon-check/>
                </icon-base>
              </td>
            </tr> -->
            <tr class="table__tr table__tr_btn-row">
              <td class="table__td table__td_item"></td>
              <td class="table__td table__td_btn">
                <button-el v-if="freeIsSelected" disabled class="button">Your plan</button-el>
                <button-el v-else @click="setNewTariff(freeTariff)" :disabled="requestInProgress" red class="button">Change</button-el>
              </td>
              <td class="table__td table__td_btn">
                <button-el v-if="silverIsSelected" disabled class="button">Your plan</button-el>
                <button-el v-else @click="setNewTariff(silverTariff)" :disabled="requestInProgress" red class="button">Change</button-el>
              </td>
              <td class="table__td table__td_btn">
                <button-el v-if="goldIsSelected" disabled class="button">Your plan</button-el>
                <button-el v-else @click="setNewTariff(goldTariff)" :disabled="requestInProgress" red class="button">Change</button-el>
              </td>
              <td class="table__td table__td_offset"/>
            </tr>
          </tbody>
        </table>

      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { format } from 'date-fns';
import { dateFormat } from 'src/utils/config';
import subscriptionPlans from 'src/models/SubscriptionPlans';
import { formatMoney } from 'src/utils/helpers';
import { IconCheck, IconInfinity } from 'Icons';

const tariffWillBeChangedDelay = 2000;
export default {
  filters: {
    formatMoney,
    format,
  },
  data: () => ({
    showSpinner: true, // todo implement spinner
    cardIsLinked: false,
    requestInProgress: false,
  }),
  computed: {
    ...mapState('subscription', [
      'tariffs',
      'currentTariff',
      'tariffWillBeChangedAt',
    ]),
    ...mapState('userNotifications', ['userNotifications']),
    subscriptionPlans: () => subscriptionPlans,
    dateFormat: () => dateFormat,
    goldTariff() {
      return this.tariffs[subscriptionPlans.gold];
    },
    silverTariff() {
      return this.tariffs[subscriptionPlans.silver];
    },
    freeTariff() {
      return this.tariffs[subscriptionPlans.free];
    },
    goldIsSelected() {
      return this.currentTariff.type === subscriptionPlans.gold;
    },
    silverIsSelected() {
      return this.currentTariff.type === subscriptionPlans.silver;
    },
    freeIsSelected() {
      return this.currentTariff.type === subscriptionPlans.free;
    },
  },
  methods: {
    ...mapActions('subscription', ['updateTariffs', 'setTariffPendingPayment', 'updateCurrentTariff']),
    setNewTariff(tariff) {
      this.requestInProgress = true;
      if (!this.cardIsLinked && tariff.type !== subscriptionPlans.free) {
        this.setTariffPendingPayment(tariff);
        this.$router.push('/subscription/change-tariff');
        return;
      }
      this.$apiService.changeTariffPlan(tariff.id).then(() => {
        setTimeout(() => {
          this.$router.push('/subscription');
        }, tariffWillBeChangedDelay);
      }).catch(() => {
        this.requestInProgress = false;
      });
    },
  },
  created() {
    Promise.all([
      this.updateTariffs(),
      this.updateCurrentTariff(),
      this.$apiService.getPaymentCardInfo().then((cardInfo) => {
        if (cardInfo.lastDigits) {
          this.cardIsLinked = true;
        }
      }),
    ]).then(() => {
      this.showSpinner = false;
    });
  },
  watch: {
    tariffWillBeChangedAt: {
      immediate: true,
      handler(val) {
        if (val) {
          this.$router.push('/subscription');
        }
      },
    },
  },
  components: {
    IconCheck,
    IconInfinity,
  },
};
</script>


<style lang="scss" scoped>
.background {
  @include background;
}
.container {
  @include container;
  background: $white-color2;
  border-radius: 5px;
  padding-top: 29px;
}
.head-title {
  margin-bottom: 7px;
  padding: 0 30px;
}
.subscription-plan {
  &__starting {
    @include font(14px);
    line-height: 20px;
    padding: 0 30px;
  }
  &__name {
    text-transform: uppercase;
    @include font(24px, $black-color1, 500);
    margin-bottom: 7px;
  }
  &__cost {
    @include font(16px, $red-color3, 500);
  }
}
.table {
  margin-top: 26px;
  width: 100%;
  border-collapse: collapse;
  &__td,
  &__th {
    width: 25%;
    text-align: left;
    border: 1px solid $white-color5;
    &:first-child {
      border-left: none;
    }
    &:last-child {
      border: none;
    }
    &_offset {
      display: none;
    }
    &:nth-last-child(2) {
      border-right: none;
    }
  }
  &__th {
    padding: 27px 29px;
    &_space {
      border-bottom: none;
    }
  }
  &__td {
    @include font(15px, $black-color1, 500);
    padding: 0 29px;
    height: 60px;
  }
  &__tr {
    .table__td {
      border-bottom: none;
      &_item {
        border-top: none;
        border-bottom: none;
      }
    }
  }
}
.ellipse {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  border: 2px solid $grey-color12;
}
.button {
  margin: 30px 0;
}
.icon-base {
  display: flex;
}
@media only screen and (max-width: 1280px) {
  .background {
    padding: 10px 0 56px;
  }
  .table {
    &__th {
      padding: 26px 29px;
    }
  }
}
@media only screen and (max-width : 1024px) {
  .container {
    max-width: 945px;
    padding-top: 27px;
  }
  .table {
    &__td,
    &__th {
      &:first-child {
        width: 25%;
      }
    }
    &__td {
      padding: 0 30px;
    }
    &__tr {
      &_btn-row {
        td {
          padding: 0 15px;
        }
      }
    }
  }
  .button {
    margin-left: 15px;
  }
}

@media only screen and (max-width : 940px) {
  .button {
    margin: 30px auto;
  }
}
@media only screen and (max-width : 768px) {
  .container {
    max-width: 688px;
    padding-top: 26px;
  }
  .background {
    padding: 10px 0 67px;
  }
  .head-title {
    padding: 0 30px;
  }
  .table {
    &__td,
    &__th {
      &:first-child {
        width: 21%;
      }
      &:not(:first-child):not(:last-child) {
        min-width: 91px;
        text-align: center;
      }
    }
    &__td {
      padding: 0 20px;
      &_item {
        font-size: 13px;
      }
      &_btn {
        @include incrSelectorWeight(1) {
          padding: 0;
        }
      }
    }
    &__th {
      padding: 26px 0;
    }
  }
}

@media only screen and (max-width : 680px) {
  .background {
    padding: 5px 5px 67px;
  }
  .button {
    @include incrSelectorWeight(1) {
      border: none;
      font-size: 10px;
      padding: 0;
      margin: auto;
      &:hover {
        background: none;
        color: $red-color3;
      }
    }
  }
  .table {
    overflow-y: auto;
    display: block;
    &__td,
    &__th {
      &:first-child:not(.table__td_item) {
        padding: 24px 72px 22px 35px;
      }
      &_btn,
      &_item {
        height: 42px;
      }
      &_item {
        @include incrSelectorWeight(1) {
          padding: 20px 72px 20px 35px;
        }
      }
      &:nth-last-child(2) {
        border-right: 1px solid $white-color5;
      }
    }
    &__th {
      padding: 26px 0 33px;
    }
  }
  .subscription-plan {
    &__name {
      font-size: 14px;
      margin-bottom: 18px;
    }
    &__cost {
      font-size: 10px;
    }
  }
  .head-title {
    padding: 0 30px;
    line-height: 29px;
  }
}

@media only screen and (max-width : 445px) {
  .table {
    &__td,
    &__th {
      &_offset {
        width: 40px;
        display: block;
      }
    }
  }
  .table-wrap {
    position: relative;
    overflow-x: hidden;
    &:after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      right: -5px;
      width: 45px;
      height: 100%;
      pointer-events: none;
      background-color: $white-color7;
      filter: blur(4px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/subscription/Plans.vue